import { cssColorValue, desktopBallad } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { FrodorTextLink } from '../Link/Link';
export const FooterTextLink = styled(FrodorTextLink) `
  && {
    line-height: normal !important;
    text-decoration: none;
    color: ${props => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.secondaryText) !== null && _b !== void 0 ? _b : cssColorValue('textSubdued'); }};
    ${() => desktopBallad}
    &:hover {
      text-decoration: none;
      color: ${props => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.primaryText) !== null && _b !== void 0 ? _b : cssColorValue('textBase'); }};
    }
  }
`;
//# sourceMappingURL=Link.js.map